import { EventEmitter, Injectable, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FingerPrintService } from './fingerprint.service';

@Injectable({
  providedIn: 'root'
})
export class FingerPrintInitService {
  observerCount: number = 0;
  @Output() emitCaptureEvent: EventEmitter<any> = new EventEmitter<any>();
  constructor(public fingerPrintService: FingerPrintService) {

  }
  fingerPrintInit;
  currrentModule = 0;

  Initialize(modType) {
    //   if(!this.fingerPrintInit) {
    if (environment.isFingerPrintEnabled) {
      this.fingerPrintInit = new this.fingerPrintService.FingerprintSdkTest(this.fingerPrintService);
    }

    //  }

    this.fingerPrintService.captureEventEmitter.subscribe((obj) => {
      let fingerObj = {
        UserId: 0,
        ImageData: obj.ImageData,
        Data: obj.Data,
        CbeffId: obj.CbeffId,
        Width: obj.width,
        Height: obj.height,
        Resolution: obj.resolution,
        Initials: null,
        Pin: null
      }


      //   this.fingerPrintObject = fingerObj;
      if (this.fingerPrintService.moduleType == 3 && modType == this.currrentModule && this.observerCount == 0) {
        this.callCompareFingerEndpoint(fingerObj);
        this.observerCount++;
      }


    });
  }
  startCapture() {
    if(this.fingerPrintInit){
      this.fingerPrintInit.startCapture();
    }
  }

  stopCapture() {
    this.fingerPrintInit.stopCapture();
  }



  callCompareFingerEndpoint(fingerObj) {

    this.fingerPrintService.compareFingerEndpoint(fingerObj).pipe(take(1)).subscribe((response: any) => {
      console.log('response', response);
      this.observerCount = 0;
      if (response.Success) {
        //    this.isFingerprintAcquired = true;
        this.fingerPrintService.userId = response.Id;
        this.fingerPrintService.isFingerPrintUsed = true;
        // this.initials = '';
        // this.pin = '';
        // this.fingerPrintAuthModal.hide();
        // this.emitSuccess.emit(true);
        this.emitCaptureEvent.emit({ caltureResponse: response, modType: this.currrentModule });
      } else {
        // this.isFingerprintAcquired = false;
        // this.fingerprintMessage = response.Message;
        this.emitCaptureEvent.emit({ caltureResponse: response, modType: this.currrentModule });
      }

    }, err => {
      this.observerCount = 0;
      this.emitCaptureEvent.emit({ success: false, modType: this.currrentModule });
    });
  }
}